import { LayoutProps } from './VideoViewsLayout';
import useVideoViewLayout from '$Utilities/hooks/useVideoLayout';
import { useEffect, useState } from 'react';
import { React } from 'Imports';
import VideoBox from './VideoBox';
import VideoSecondaryBar from './VideoSecondaryBar';

const styles = require('./Layouts.scss') as {
    secondaryVideoBarViewBox: string;
};

const SingleView = (props: LayoutProps) => {
    const [transitionEffect, setTransitionEffect] = useState(false);
    const mainVideoHeight = 550;

    const { mainVideos, secondaryVideos } = useVideoViewLayout(props.videoAssets, props.primaryChannelNumber, 'Single');

    useEffect(() => {
        setTransitionEffect(true);
    }, [props.videoAssets]);

    return (
        <>
            <div>
                {mainVideos.map((video, idx) => (
                    <VideoBox
                        key={idx}
                        video={video}
                        transitionEffect={transitionEffect}
                        height={mainVideoHeight}
                        maxHeight={mainVideoHeight}
                        onVideoDownloaded={props.onVideoDownloaded}
                    />
                ))}
            </div>
            {secondaryVideos.length > 0 && (
                <div>
                    <VideoSecondaryBar
                        videos={secondaryVideos}
                        transitionEffect={transitionEffect}
                        height={143}
                        itemClassName={styles.secondaryVideoBarViewBox}
                        onVideoDownloaded={props.onVideoDownloaded}
                    />
                </div>
            )}
        </>
    );
};

export default SingleView;
